/** Where a link opens. "external" additionally reads as leaving the app. */
export type LinkDestination = "new-tab" | "external";

/** The anchor attributes a destination implies. Both destinations open a new tab. */
export const destinationAttrs = (destination: LinkDestination | undefined) => ({
  target: destination ? ("_blank" as const) : undefined,
  rel: destination ? "noopener noreferrer" : undefined,
});
